<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="picker mResult">
      <van-field :label="field.options.label" :required="field.options.required" readonly clickable :value="selectedValue"
        :placeholder="field.options.placeholder" @click="showPicker = true" :input-align="field.options.textAlign" />
      <van-calendar v-model="showPicker" :title="field.options.title" :disabled-date="disableDate"
        :default-date="defaultDate" :formatter="formatter" :min-date="minDate" :max-date="maxDate" @confirm="confirm"
        @select="select" />
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import { isNull } from "@/utils/util";
import dayjs from "@/utils/dayjs.min.js";

export default {
  name: "calendarWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      defaultDate: new Date(),
      calendarData: [], // 存储接口返回的日期数据
      fieldModel: "",
      rules: [],
      showPicker: false,
      selectedValue: "",
    };
  },
  components: {
    FormItemWrapper,
  },
  computed: {
    minDate() {
      // 禁用过去时间
      return !!this.field.options.pastDateDisabled ? new Date() : new Date('1970-1-1')
    },
    maxDate() {
      // 禁用过去时间
      return !!this.field.options.futureDateDisabled ? new Date() : new Date('2099-12-31')
    }
  },
  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initOptionItems()
    this.initEventHandler();

    this.handleOnCreated();

    this.syncUpdateFormModel("");
    this.buildFieldRules();
    this.fetchCalendarData();
    this.fieldModel = ''
  },
  watch: {
    fieldModel(key) {
      this.defaultDate = new Date(key)
    }
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    select(value) {
      let date = dayjs(value).format("YYYY-MM-DD")
    },
    confirm(value) {
      this.selectedValue = dayjs(value).format("YYYY-MM-DD")
      this.fieldModel = this.selectedValue
      this.dispatch("ElFormItem", "el.form.change", [this.fieldModel]);
      this.handleChangeEvent(this.fieldModel);
      this.showPicker = false
    },
    disableDate(time) {
      const disabledDates = this.calendarData.filter(item => item.a == 0).map(item => item.date);

      const year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const day = time.getDate().toString().padStart(2, '0');
      const formattedTime = `${year}-${month}-${day}`;
      return disabledDates.includes(formattedTime);
    },
    fetchCalendarData() {
      // 调用接口获取日期数据，这里使用模拟数据代替
      // 请根据实际情况替换为您的接口调用代码
      const data = this.fetchDataFromAPI();

      // 将接口返回的数据保存到calendarData数组中
      this.calendarData = data;
    },
    fetchDataFromAPI() {
      // 假设这里是您的接口请求逻辑
      // 返回一个包含日期的数组
      // 实际情况下，请根据您的接口返回进行处理
      const mockData = [
        { date: '2023-08-02', a: 15, b: 16 },
        { date: '2023-08-03', a: 0, b: 18 },
        // 其他日期和时间...
      ];

      return mockData.filter((item) => {
        return +new Date(item.date) >= new Date(dayjs(new Date()).format('YYYY-MM-DD'))
      })
    },
    formatter(day) {
      const date = day.date;

      // 判断当前日期是否在接口返回的日期和时间数据数组中
      const data = this.calendarData.find((item) => {
        const itemDate = new Date(item.date);
        return (
          itemDate.getFullYear() === date.getFullYear() &&
          itemDate.getMonth() === date.getMonth() &&
          itemDate.getDate() === date.getDate()
        );
      });
      if (data) {
        const timeData = data.a + '/' + data.b;
        // 判断时间是否为空
        if (timeData) {
          // 组合显示日期和时间
          const displayText = timeData

          // 将组合后的字符串作为日期单元格的内容
          day.bottomInfo = displayText;
        }
      }

      return day;
    },

    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value)) {
            _this.aa()

            callback(new Error(
              _this.aa()
            ));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.area-input {
  height: 36px;
  border: 1px solid #ccc;
  padding-left: 10px;
}


.close {
  text-align: center;
  border-top: 1px solid #DCDFE6;
}
</style>
